module.exports = __webpack_public_path__ + "static/media/logo-text-inline-140x24.f604951b.svg";